import React from "react";
import { Card, CardHeader, CardTitle, Row, Col } from "reactstrap";
import axios from "axios";
import { PanelHeader, Button } from "components";
import { message, Space, Input, Modal, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import Refunds from "./components/Refunds";
import BillingResources from "./components/BillingResources";
import { backoffice } from "../../utils/axios/backoffice";

const { Dragger } = Upload;

class BillsDashboard extends React.Component {
  constructor(props) {
    super(props);
    let currentCustomer = null;
    try {
      currentCustomer = this.props.mainState.user.uuid;
    } catch (error) {
      console.error("No se pudo obtener el usuario: ", error);
    }
    if (!props.userData.isBillingDepartmentN1()) this.redirectTo("/dashboard");

    this.state = {
      currentBillStatus: null,
      isGenerateModalOpen: false,
      isChangeBillStatusModalOpen: false,
      password: "",
      isUploadModalOpen: false,
      uploadFileList: [],
      isFileUploading: false,
      customer: currentCustomer,
    };
    this.fileInputRef = React.createRef();
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.getTotalCustomers = this.getTotalCustomers.bind(this);
    this.getProcessingBills = this.getProcessingBills.bind(this);
    this.handleUploadCancel = this.handleUploadCancel.bind(this);
    this.handleBeforeUpload = this.handleBeforeUpload.bind(this);
    this.handleGenerateBilling = this.handleGenerateBilling.bind(this);
  }

  componentDidMount = () => {
    this.getProcessingBills();
    this.getTotalCustomers();
  };
  getTotalCustomers = async () => {
    try {
      const csrfToken = localStorage.getItem("token");
      const response = await axios.post(
        "https://oficina.nadunet.es/api/rest/nadunet_billing_resources/count_monthly_renewable_customers",
        {
          verify_token:
            "5yE598k3QK2frjmak8RVIzWfRCsZGk09vHY2QD6VotCo5CoLdmokyUO9FrXLUFjb",
        },
        {
          headers: {
            "X-CSRF-Token": csrfToken,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.data && response.data.ok) {
        this.setState({ customers_count: response.data.count });
      }
    } catch (error) {
      console.error("Error fetching sepa info:", error);
      message.error("Error al obtener la información SEPA");
    }
  };
  getProcessingBills = async () => {
    try {
      const csrfToken = localStorage.getItem("token");
      const response = await axios.post(
        "https://oficina.nadunet.es/api/rest/nadunet_billing_resources/count_processing_bills",
        {
          verify_token:
            "5yE598k3QK2frjmak8RVIzWfRCsZGk09vHY2QD6VotCo5CoLdmokyUO9FrXLUFjb",
        },
        {
          headers: {
            "X-CSRF-Token": csrfToken,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.data && response.data.ok) {
        this.setState({ bills_count: response.data.count });
      }
    } catch (error) {
      console.error("Error fetching sepa info:", error);
      message.error("Error al obtener la información SEPA");
    }
  };
  componentWillUnmount = () => {};
  handleFileUpload = async () => {
    if (this.state.isFileUploading) return;
    this.setState({ isFileUploading: true, isUploadModalOpen: false });
    const { uploadFileList } = this.state;
    const filePromises = uploadFileList.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    });
    try {
      const csrfToken = localStorage.getItem("token");
      const base64Files = await Promise.all(filePromises);
      axios.post(
        "https://oficina.nadunet.es/api/rest/nadunet_billing_resources/load_returns",
        {
          sepa_return_zips: base64Files,
        },
        {
          headers: {
            "X-CSRF-Token": csrfToken,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      message.success("Archivos cargados correctamente");
    } catch (error) {
      message.error("Error al cargar los archivos");
      console.error("Error al cargar archivos:", error);
    }
    this.setState({ isFileUploading: false, uploadFileList: [] });
  };
  handleGenerateBilling = () => {
    try {
      backoffice.post("/bills/generate", {
        pass: this.state.password,
      });
      this.setState({ isGenerateModalOpen: false, password: "" });
    } catch (error) {
      console.error("Error generating billing:", error);
      message.error("Error al generar la facturación");
    }
  };
  handleSetBillsAsPaid = () => {
    try {
      backoffice.post("/bills/set-paid", {
        pass: this.state.password,
      });
      this.setState({ isChangeBillStatusModalOpen: false, password: "" });
    } catch (error) {
      console.error("Error al cambiar el estado de las facturas:", error);
      message.error("Error al cambiar el estado de las facturas");
    }
  };
  triggerFileInput = () => {
    this.fileInputRef.current.click();
  };
  handleBeforeUpload = (file, fileList) => {
    if (!file.name.toLowerCase().endsWith(".zip")) {
      message.error("Solo se permiten archivos .zip");
      return Upload.LIST_IGNORE;
    }
    this.setState({
      uploadFileList: [...this.state.uploadFileList, ...fileList],
    });
    return false;
  };
  handleUploadCancel = () => {
    this.setState({ isUploadModalOpen: false, uploadFileList: [] });
  };

  render() {
    const {
      isGenerateModalOpen,
      isChangeBillStatusModalOpen,
      password,
      isUploadModalOpen,
      uploadFileList,
      bills_count,
      customers_count,
    } = this.state;
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Card>
              <CardHeader>
                <CardTitle>
                  <span>Dashboard de facturación</span>
                </CardTitle>
              </CardHeader>
            </Card>
          </Row>
          <Modal
            title="Cargar devoluciones"
            open={isUploadModalOpen}
            onCancel={this.handleUploadCancel}
            onOk={this.handleFileUpload}
            okText="Subir"
            cancelText="Cancelar"
          >
            <Dragger
              multiple
              accept=".zip"
              beforeUpload={this.handleBeforeUpload}
              fileList={uploadFileList}
              style={{ padding: "20px 0" }}
              onRemove={(file) => {
                this.setState(({ uploadFileList }) => ({
                  uploadFileList: uploadFileList.filter(
                    (f) => f.uid !== file.uid
                  ),
                }));
              }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Arrastra archivos aquí o haz clic para subir
              </p>
              <p className="ant-upload-hint">
                Soporte para múltiples archivos .zip
              </p>
            </Dragger>
          </Modal>
          {isGenerateModalOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: "auto",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  width: "auto",
                  backgroundColor: "white",
                  padding: 20,
                  borderRadius: 10,
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <h2 style={{ margin: 0 }}>Generar Facturación</h2>
                <p>¿Estás segur@ de que deseas generar la facturación?</p>
                <Input.Password
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                  }}
                >
                  <Button
                    type="default"
                    style={{ width: 100 }}
                    onClick={() =>
                      this.setState({ isGenerateModalOpen: false })
                    }
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="primary"
                    style={{ width: 100, backgroundColor: "#4CAF50" }}
                    onClick={this.handleGenerateBilling}
                  >
                    Confirmar
                  </Button>
                </div>
              </div>
            </div>
          )}
          {isChangeBillStatusModalOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: "auto",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  width: "auto",
                  backgroundColor: "white",
                  padding: 20,
                  borderRadius: 10,
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <h2 style={{ margin: 0 }}>
                  Cambiar de 'Procesando' a 'Pagado'
                </h2>
                <p>
                  ¿Estás segur@ de que deseas cambiar el estado de las factura?
                </p>
                <Input.Password
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                  }}
                >
                  <Button
                    type="default"
                    style={{ width: 100 }}
                    onClick={() =>
                      this.setState({ isChangeBillStatusModalOpen: false })
                    }
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="primary"
                    style={{ width: 100, backgroundColor: "#4CAF50" }}
                    onClick={this.handleSetBillsAsPaid}
                  >
                    Confirmar
                  </Button>
                </div>
              </div>
            </div>
          )}
          <BillingResources />
          <Row>
            <Col xs={12}>
              <Card className="card-plain">
                <Space wrap>
                  <span className="h5">Funcionalidades</span>
                </Space>
                <div
                  style={{
                    width: "100%",
                    marginTop: 10,
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: 10,
                  }}
                >
                  <Button
                    type="default"
                    size="large"
                    style={{ margin: 0, flex: 1 }}
                    onClick={() => this.setState({ isUploadModalOpen: true })}
                  >
                    Cargar devoluciones
                  </Button>
                  <Button
                    type="default"
                    size="large"
                    style={{ margin: 0, flex: 1 }}
                    disabled={!customers_count || customers_count === 0}
                    onClick={() => this.setState({ isGenerateModalOpen: true })}
                  >
                    {customers_count !== undefined ? (
                      <span>
                        Generar facturación ({customers_count} clientes)
                      </span>
                    ) : (
                      <span>Generar facturación (... clientes)</span>
                    )}
                  </Button>
                  <Button
                    type="default"
                    size="large"
                    style={{ margin: 0, flex: 1 }}
                    disabled={!bills_count || bills_count === 0}
                    onClick={() =>
                      this.setState({ isChangeBillStatusModalOpen: true })
                    }
                  >
                    {bills_count !== undefined ? (
                      <span>
                        Cambiar {bills_count} facturas de 'Procesando' a
                        'Pagada'
                      </span>
                    ) : (
                      <span>
                        Cambiar ... facturas de 'Procesando' a 'Pagada'
                      </span>
                    )}
                  </Button>
                </div>
              </Card>
            </Col>
          </Row>
          <Refunds customer={this.state.customer} />
        </div>
      </div>
    );
  }
}

export default BillsDashboard;



// WEBPACK FOOTER //
// ./src/views/Bills/BillsDashboard.jsx